interface ISliderDotsProps {
  images: Array<string>;
  setCurrentIndex: React.Dispatch<React.SetStateAction<number>>;
  currentIndex: number;
}

const SliderDots = ({
  images,
  setCurrentIndex,
  currentIndex,
}: ISliderDotsProps) => {
  return (
    <>
      <div className={'slider__dots py-2'}>
        {images.map((_, index) => (
          <div
            key={index}
            className={
              'slider__dots__item ' +
              (index === currentIndex
                ? 'slider__dots__item__active'
                : 'slider__dots__item__deactive')
            }
            onClick={() => setCurrentIndex(index)}
          ></div>
        ))}
      </div>
    </>
  );
};
export default SliderDots;
